<template>

  <div>
      <link href="http://cdn.quilljs.com/1.3.4/quill.snow.css" rel="stylesheet">
    <link href="http://cdn.quilljs.com/1.3.4/quill.bubble.css" rel="stylesheet">
    <link href="http://cdn.quilljs.com/1.3.4/quill.core.css" rel="stylesheet">
    <div class="news-info-banner" v-bind:style="{backgroundImage:'url(' + bg + ')'
    ,backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize: 'cover'}">
      <head-menu   fd="0"  current="3"></head-menu>
      <img :src="bg" class="news-info-banner-img" style="display:block;width: 100%;position: relative;z-index: -100">
    </div>

    <div style="max-width: 1210px;margin: 0 auto;height: 54px;position: relative;top:-27px;box-shadow:1px 1px 5px 0px rgba(0, 0, 0, 0.2);background-color: #fff">
      <div style="max-width: 1210px;height: 40px;margin: 0 auto">
      <div style="text-align: center;height: 54px;line-height: 54px;float: left;font-size:14px;margin-left: 40px;overflow: hidden">
        <span class="returnNews" @click="returnNewsCenter">新闻中心 </span>><span> {{title}}</span>
      </div>
      </div>
    </div>

    <div style="text-align: center;font-size:24px;margin-right: auto;margin-left: auto;margin-top: 30px;margin-bottom: 20px;padding-right: 20px;padding-left: 20px">
     {{title}}
    </div>
    <div id="newsinfo" style="max-width: 1210px;margin: 0 auto;margin-top: 30px"  class="ql-snow ql-editor" v-html="body"></div>
     <!-- <div id="newsinfo" style="max-width: 1210px;margin: 0 auto;margin-top: 30px"  class="ql-snow ql-editor">
       <p>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp道远资本在辅助生殖业务领域的投资可谓是首屈一指。不仅投资了国内最大的辅助生殖医疗连锁机构锦欣生殖，同时道远资本对贝康医疗的早期投资，今天也迎来了高光时刻。.HK，发行价格为27.36港元/股，发行市值为73亿港元；上市当天，贝康医疗开盘价为30港元/股，开盘市值为80亿港元。道远资本于2016年投资贝康医疗，本次贝康医疗开盘市值为道远资本投资时估值的28倍。贝康医疗是中国辅助生殖基因检测解决方案最领先的创新平台，道远资本看好由创始人梁波博士带领的高水平科研团队在生育健康分子检测领域的技术和资源积淀，贝康医疗获得了国内首张也是目前唯一一张PGT-A三类医疗器械注册证，成为多家知名辅助生殖中心的合作伙伴。</p>
       <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp据融资中国获悉，目前中国专注于辅助生殖业务并以辅助生殖题材上市的公司仅有两家，一家是2019年6月于港股挂牌的国内最大的辅助生殖医疗连锁机构锦欣生殖（股票代码：01951.HK），目前为恒生综指成分股，市值470亿。另一家就是今日于港股挂牌的辅助生殖基因检测解决方案提供商——贝康医疗。 </span>
       <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp而道远资本在这两个项目上的成功投资，无疑使其成为这个投资赛道引人瞩目的领跑者。</span>
       <br>
      <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp道远资本介绍说，公司创立伊始就高度关注辅助生殖行业。2016年在中美两国不孕率均为15%的情况下，中国辅助生殖渗透率仅为6.1%，约为美国的五分之一，潜在提升空间甚大。近年来受环境、压力、饮食等多种因素的影响，中国患者人数已超过5000万，以25岁至30岁人数最多，呈年轻化趋势。而2016年国家全面放开“二孩”政策，又为辅助生殖市场增添了催化剂。在更年轻的人群，辅助生殖不仅仅是解决不能生育，而是解决高效、精准生育的手段。随着消费水平提升，有迫切生育需求的家庭对辅助生殖的价格不敏感。以上因素驱动中国辅助生殖市场持续发展，2016年可以说是投资的黄金时点。</span>
      <br>
      <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp据道远资本介绍，2016年，道远资本对贝康医疗的早期投资，也是道远资本在深入研究辅助生殖行业之后的首次亮相。贝康医疗是中国辅助生殖基因检测解决方案领先的创新平台，道远资本看好由创始人梁波博士带领的高水平科研团队在生育健康分子检测领域的技术和资源积淀。团队研发的基于高通量检测技术平台的胚胎植入前染色体非整倍体检测试剂盒（PGT-A）区别于以往的FISH和Array CGH等检测方法，可快速、精准地通过测序技术针对胚胎染色体的数目和结构异常进行检测，从中高效筛选出在染色体水平正常的胚胎植入子宫，提高胚胎植入的成功率。2017-2019年贝康积极推动PGT产品国家标准建立，并获得国家创新医疗器械特别审批。2020年初，贝康的PGT-A产品获得中国首张且是目前唯一一张PGT-A三类医疗器械注册证，成为多家知名辅助生殖中心的合作伙伴。贝康医疗厚积薄发，于2021年2月8日登录港股，发行市值72.96亿元港币，加速公司进军辅助生殖乃至生育健康的星辰大海。</span>
       <br>
       <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp同年，道远资本旗下基金完成对锦欣生殖的首轮投资。辅助生殖中心是国家政策强监管的医疗机构，牌照稀缺。截至2016年底，中国获许可的辅助生殖机构共有451家，其中327家持有试管婴儿IVF牌照。在327家医疗机构中，仅35家为民营机构。道远资本相信锦欣生殖作为有人才、技术和管理积淀的企业，一定会大有作为。2016年，锦欣生殖完成8711个IVF周期，收入3.46亿元。根据弗若斯特沙利文（北京）咨询有限公司上海分公司编制有关中美ARS市场的市场研究报告，2018年，锦欣生殖在中国进行了20958个IVF取卵周期，约占中国总市场份额的3.1%，在中国ARS市场中排名第三，根据相同指标，在中国民营ARS供应商中排名第一；锦欣生殖旗下的HRC Fertility（包括由HRC Management根据管理服务协议管理的HRC Medical）于2018年在美国西部ARS市场中排名第一。锦欣生殖已成长为中美领先的民营辅助生殖中心，于2019年登陆港股，并被列入恒生指数。</span>
       <br>
       <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp道远资本董事长章达峰表示，道远资本将持续关注和布局辅助生殖这一优质赛道，坚信中国的辅助生殖渗透率会追赶发达国家水平，辅助生殖中心、患者对于成功率的追求将促进精准诊断、胚胎优选需求放大。首先，辅助生殖服务中心属拥有高政策准入壁垒、集中度低、对于专科医疗服务的安全性、技术稳定性和服务的质量有高要求的细分行业。道远资本仍然看好在一定程度上实现辅助生殖服务流程的标准化管理和规模效应，并具备一定的跨区域扩张和整合能力的服务机构。其次，辅助生殖实验室是辅助生殖成功与否的关键因素。实验室内操作属人力密集型工作，未来智能化、自动化设备将在一些标准化环节取代人工，提高效率；随着分子技术整体水平的发展，针对精子、卵子、受精卵的检测分析更加精准、全面，可进一步提升辅助生殖的成功率；实验室使用的耗材将加速实现进口替代。</span>    
     </div> -->
    <div class="returnNewsCenter returnNewsCenterMargin" @click="returnNewsCenter">返回新闻列表</div>
    <div style="height: 100px"></div>


    <footee></footee>

  </div>

</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import HeadMenu from '@/share/head-mean'
  import footee from '@/share/footer.vue'
  import BK from '@/share/fh.vue'
  export default {
    components:{
      "head-menu":HeadMenu,
      "footee":footee,
      "BK":BK
    },
    name: "newsCenteru",
    data(){
      return {
        bg: require('@/assets/newsCenteru/12.png'),
        activeIndex:'道远资本观察',
        type:1,
        thisId:'',
        title:"辅助生殖赛道投资的领跑者！",
        body:"",
        newList:[
          {
            tiles:'新冠病毒确诊的主要检测方法',
            info:'道远资本是一家专注于医疗健康领域的领先股权投资机构，致力于用资本的力量和产业资源帮助优秀医疗健康企业快速成长，为社会提供更好的医疗产品和服务，增进人类健康...',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-18',
            isShow:false
          },{
            tiles:'新冠病毒确诊的主要检测方法',
            info:'道远资本是一家专注于医疗健康领域的领先股权投资机构，致力于用资本的力量和产业资源帮助优秀医疗健康企业快速成长，为社会提供更好的医疗产品和服务，增进人类健康...',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-18',
            isShow:false
          },{
            tiles:'新冠病毒确诊的主要检测方法',
            info:'道远资本是一家专注于医疗健康领域的领先股权投资机构，致力于用资本的力量和产业资源帮助优秀医疗健康企业快速成长，为社会提供更好的医疗产品和服务，增进人类健康...',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-18',
            isShow:false
          },{
            tiles:'新冠病毒确诊的主要检测方法',
            info:'道远资本是一家专注于医疗健康领域的领先股权投资机构，致力于用资本的力量和产业资源帮助优秀医疗健康企业快速成长，为社会提供更好的医疗产品和服务，增进人类健康...',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-18',
            isShow:false
          },{
            tiles:'新冠病毒确诊的主要检测方法',
            info:'道远资本是一家专注于医疗健康领域的领先股权投资机构，致力于用资本的力量和产业资源帮助优秀医疗健康企业快速成长，为社会提供更好的医疗产品和服务，增进人类健康...',
            imgUrl:require('@/assets/newsCenteru/imgNR.png'),
            time:'2020-03-18',
            isShow:false
          }

        ]


      }
    },created() {
      //路由传过来的ID参数
      this.thisId=this.$route.params.id
      console.log(this.thisId)
      this.getNewsBody(this.thisId)
    },methods:{
      handleSelect(key){
        this.activeIndex=key
      },
      over(varx){
        for(let index=0;index<this.newList.length;index++){
          if(varx===index){
            this.newList[index].isShow=true
          }else{
            this.newList[index].isShow=false
          }
        }
      },dataList(varx){
        if(varx===1){
          this.type=1
        }else if(varx===2){
          this.type=2
        }else{
          this.type=3
        }
      },linkinfo(){

      },
      getNewsBody(varx){
        console.log("调用方法")
        this.$axios.post('/newsCenter/getNewsBody',{
          id:varx
        })
          .then((res)=>{
          console.log(res.data)
            this.title=res.data.entity.title
            this.body=res.data.entity.body
          })
          .catch((err)=>{
          console.log(err)
          })
      },
      returnNewsCenter(){
        this.$router.push({path:'/newsCenter'})
      }
    }
  }
</script>

<style scoped>

  @media screen and (min-width: 750px){
   .returnNewsCenterMargin{
     margin-left: auto;
   }
    .newsInfo-banner-height{
      height:400px
    }

  }
  @media screen and (max-width: 750px){
   .returnNewsCenterMargin{
        margin-left: 10%;
   }
    .newsInfo-banner-height{
    height:200px
    }
  }

  @media screen and (min-width: 1210px){

    .news-info-banner-img{
      display: none !important;
    }



  }

  @media screen and (min-width: 1210px){
    .news-info-banner{
      height: 400px;
    }


  }

   .ql-snow img{
    display: block;
    width: 100%;
    max-width: 1210px
  }
  .returnNewsCenter{
    cursor: pointer;
    max-width: 1210px;
    margin-top: 93px;

    margin-right: auto;
    font-weight:400;
    color:rgba(8,58,111,1);
  }
  .returnNews{
    cursor: pointer;
  }
  .itemx-our-1{
    height: 54px !important;
    line-height: 54px !important;
    margin-top: 0px !important;
  }
  .xz1{
    border-bottom: 2px solid #083A6F !important;
  }
  .news-Centeru-nr{
    width: 1210px;
    height: 300px;
    background:#FFFFFF;
    margin: 0 auto;
    margin-top:100px;
    border-bottom: 2px solid rgba(102,100,100,1);
  }
  /*.news-Centeru-nr:hover{*/
  /*  box-shadow:5px 8px 10px 0px rgba(188,188,188,0.53), -4px -8px 10px 0px rgba(188,188,188,0.15);*/
  /*  border-bottom: 2px solid rgba(8,58,111,1);*/
  /*  background-color: #fff;*/
  /*}*/
  .news-Centeru-text-one{
    font-size:16px;
    line-height:20px;
    font-weight:400;
    float: left;
  }
  .news-Centeru-text-tow{
    font-size:14px;
    font-weight:400;
    color:rgba(152,152,152,1);
    float: right;
    line-height: 29px;
  }
  .news-Centeru-text-three{
    margin-top: 45px;
    color:rgba(152,152,152,1);
    line-height:28px;
    font-size: 14px;
  }
  .news-Centeru-tile{
    margin-top: 70px;
    text-align: center;
    font-size:18px;
    font-weight:400;
  }
  /deep/ .el-menu-item{
    padding: 0px;
  }
  /deep/ .el-menu--horizontal>.el-menu-item.is-active{
    font-weight:bold;
    color:rgba(8,58,111,1);
    border-bottom: 0px;
  }
  /*/deep/ #newsinfo *{*/
    /*font-family:Microsoft YaHei !important;*/
  /*}*/

  /deep/ #newsinfo img{
    display: block;width: 100%;margin-right: auto;margin-left:auto;max-width: 1210px
  }
  .gd{
    height: 150px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/newsCenteru/NewInfo.vue